"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.ThemeProvider = void 0;
var react_1 = __importStar(require("react"));
var icon_theme_webp_1 = __importDefault(require("../assets/images/icon_theme.webp"));
var ThemeContext = (0, react_1.createContext)(undefined);
var ThemeProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(function () {
        var savedTheme = localStorage.getItem('theme');
        return savedTheme ? savedTheme : 'light';
    }), theme = _b[0], setTheme = _b[1];
    var toggleTheme = function () {
        var newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
        var icon = document.getElementById('theme-icon');
        icon.src = icon_theme_webp_1.default;
    };
    (0, react_1.useEffect)(function () {
        var root = document.documentElement;
        var body = document.body;
        // var a = document.querySelectorAll('a');
        // var ul = document.querySelectorAll('ul');
        root.style.setProperty('--decorative-line-color', '#6f836e66');
        if (theme === 'light') {
            root.style.setProperty('--burger-menu-background-color', '#ffffff');
            root.style.setProperty('--background-color', '#ffffff'); // светлый фон
            root.style.setProperty('--main-color', "".concat(process.env.MAIN_COLOR)); // основной цвет
            root.style.setProperty('--hover-main-color', "".concat(process.env.HOVER_MAIN_COLOR)); // основной цвет при наведении
            //root.style.setProperty('--main-color', '#0c51d1'); // основной цвет
            // root.style.setProperty('--main-color', '#0f8921'); // основной цвет
            root.style.setProperty('--inverse-text-color', '#ffffff'); // цвет текста
            root.style.setProperty('--header-background-color', '#ffffff'); // цвет фона заголовка
            root.style.setProperty('--header-active-background-color', '#ffffff'); // активный заголовок
            root.style.setProperty('--main-text-color', '#212529'); // основной текст
            root.style.setProperty('--light-text-color', '#6c757d'); // светлый текст
            root.style.setProperty('--swiper-slide-background', '#ffffff');
            root.style.setProperty('--btn-color', '#ffffff');
            root.style.setProperty('--vector-color', '#ffffff');
            root.style.setProperty('--container-background-color', '#f9fafb');
            root.style.setProperty('--table-row-color', '#f9fafb'); //цвет строчки в таблице
            root.style.setProperty('--inverse-table-row-color', '#f5f5f5');
            body.style.backgroundColor = '#ffffff'; // цвет фона для body
        }
        else {
            // .BurgerMenu-module__burger_menu #423224
            root.style.setProperty('--burger-menu-background-color', '#212529');
            root.style.setProperty('--background-color', '#212529'); // цвет фона для темной темы
            root.style.setProperty('--main-color', "".concat(process.env.MAIN_COLOR)); // основной цвет
            root.style.setProperty('--hover-main-color', "".concat(process.env.HOVER_MAIN_COLOR)); // основной цвет при наведении
            //root.style.setProperty('--main-color', '#0c51d1'); // основной цвет для темной темы
            // root.style.setProperty('--main-color', '#0f8921'); // основной цвет
            root.style.setProperty('--inverse-text-color', '#ffffff'); // текст для темной темы
            root.style.setProperty('--header-background-color', '#495057'); // цвет фона для заголовка в темной теме
            root.style.setProperty('--header-active-background-color', '#212529'); // цвет фона для активного заголовка в темной теме
            root.style.setProperty('--main-text-color', '#ffffff');
            root.style.setProperty('--light-text-color', '#a9a9a9');
            root.style.setProperty('--swiper-slide-background', '#212529');
            root.style.setProperty('--btn-color', '#ffffff');
            root.style.setProperty('--vector-color', '#212529');
            root.style.setProperty('--container-background-color', '#000000');
            root.style.setProperty('--table-row-color', '#afafaf'); //темный цвет строчки в таблице
            root.style.setProperty('--inverse-table-row-color', '#9d9d9d');
            body.style.backgroundColor = '#000000';
            // #root > div > main > section.InStock-module__in_stock--aatpm > div > div > div > ul > li:nth-child(24)
            // a.forEach((link) => {
            //     link.style.color = 'white'; // Correctly set the color for each anchor element
            // });
            // ul.forEach((list) => {
            //     list.style.color = 'black';
            // });
        }
    }, [theme]);
    return react_1.default.createElement(ThemeContext.Provider, { value: { theme: theme, toggleTheme: toggleTheme } }, children);
};
exports.ThemeProvider = ThemeProvider;
var useTheme = function () {
    var context = (0, react_1.useContext)(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
exports.useTheme = useTheme;
